import type { DateTime } from 'luxon';

import {
	isLaterToday,
	isTomorrow,
	isStartOfDay,
	isEndOfDayToday,
	isEndOfDay,
} from '@/app/utils/date';

const formatStart = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (isLaterToday(time)) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	if (isTomorrow(time) && isStartOfDay(time)) {
		return 'Tomorrow';
	}

	if (isTomorrow(time)) {
		return `Tomorrow, ${time.toFormat('HH:mm')}`;
	}

	if (isStartOfDay(time)) {
		return `${time.toFormat('ccc, dd LLL')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
};

const formatEnd = (time: DateTime) => {
	if (!time.isValid) {
		return '';
	}

	if (isEndOfDayToday(time)) {
		return `End of Day`;
	}

	if (isLaterToday(time)) {
		return `Today, ${time.toFormat('HH:mm')}`;
	}

	if (isTomorrow(time) && !isEndOfDay(time)) {
		return `Tomorrow, ${time.toFormat('HH:mm')}`;
	}

	if (isTomorrow(time)) {
		return `Tomorrow`;
	}

	if (!isEndOfDay(time)) {
		return `${time.toFormat('ccc, dd LLL')}, ${time.toFormat('HH:mm')}`;
	}

	return `${time.toFormat('ccc, dd LLL')}`;
};

export default {
	formatStart,
	formatEnd,
};
